export default "__VITE_ASSET__mGg8cGDI__"